const triggerRouterAddCustomer = (sessionId, country, language, userData) => {
  const headersAddCustomer = new Headers();
  const countryUpperCase = country.toUpperCase();
  const uniqueId = `web-` + generateUniqueID();
  const uniqueIdCorrelation = `web-` + generateUniqueID();
  headersAddCustomer.append("x-wu-operationname", "addCustomer");
  headersAddCustomer.append("Content-Type", "application/json");
  headersAddCustomer.append("x-wu-accesscode", "RtYV3XDz9EA");
  headersAddCustomer.append("wucountrycode", countryUpperCase);
  headersAddCustomer.append("wulanguagecode", language);
  headersAddCustomer.append("x-wu-externalRefId", uniqueId);
  headersAddCustomer.append("x-wu-correlationId", uniqueIdCorrelation);
  headersAddCustomer.append("flowName", `PRE_REGISTRATION`);
  headersAddCustomer.append("x-wu-session-version", `2`);
  headersAddCustomer.append("version", `V2`);
  headersAddCustomer.append("x-wu-sessionId", sessionId);
  headersAddCustomer.append("x-wu-apiKey", `1978`);
  headersAddCustomer.append("accept-language", `en-${countryUpperCase}`);

  let addCustomerInput = {
    customer: {
      progressiveRegistration: true,
      credential: {
        password: userData.password,
      },
      captcha: {
        answer: null,
      },
      notification: {
        thirdpartyDatasharingConsent: true,
        email: true,
        marketing: true,
      },
      termsConditions: true,
      email: userData.emailId,
    },
  };

  const graphql = JSON.stringify({
    query: registerApiQuery,
    variables: {
      args_createCustomer: addCustomerInput,
    },
  });
  const requestOptions = {
    method: "POST",
    headers: headersAddCustomer,
    body: graphql,
    redirect: "follow",
  };

  return fetchApiWu(routerUrl, requestOptions, "addCustomer");
};

window.triggerRouterAddCustomer = triggerRouterAddCustomer